// extracted by mini-css-extract-plugin
export default {"selectedItemWrap":"ViewModal_selectedItemWrap__kGu0C","selectedItemInnerWrap":"ViewModal_selectedItemInnerWrap__HXrVm","selectedItems":"ViewModal_selectedItems__NiBGr"};